/***
 * @file: 
 * @author: xiaoyu.chen
 * @Date: 2025-08-13 09:39:28
 */
export default defineAppConfig({
  primaryColor: '#0f1620',
  darkPrimary: '#0f1620',
  lightPrimary: '#ffffff',
  theme: {
    primaryColor: '#0f1620',
    textColor: '#a0a7b4',
    boldColor: '#3a7bd5',
    titleColor: '#ffffff',
    tagBg: 'rgba(58, 123, 213, 0.2)',
    cardBg: '#1a2130',
    tagDarkIcon: '#a0a7b4',
    textLine: 'linear-gradient(90deg, #ffffff, #3a7bd5)',
    iconBg: 'linear-gradient(135deg,rgba(58, 123, 213, .6),rgba(0, 210, 255, 1))',
    bannerBg: 'rgba(58, 123, 213, .6)',
    codeBg: 'rgba(255, 255, 255, 0.1)',
    borderColor: 'rgba(255, 255, 255, 0.1)',
    userInfoBg: 'rgba(255, 255, 255, 0.1)'
  },
  lightTheme: {
    primaryColor: '#ffffff',
    textColor: '#666666',
    boldColor: 'rgb(153, 65, 65)',
    titleColor: '#333333',
    tagBg: 'rgba(17, 12, 12, 0.2)',
    cardBg: 'rgba(193, 243, 193, 0.1)',
    tagDarkIcon: '#a0a7b4',
    textLine: 'linear-gradient(90deg,rgb(26, 20, 20), rgb(40, 87, 152))',
    iconBg: 'linear-gradient(135deg,rgb(153, 65, 65), rgba(55, 45, 106, .5))',
    bannerBg: 'linear-gradient(145deg,rgba(126, 103, 103, 0.1), rgba(248, 165, 165, 0.61))',
    codeBg: 'rgba(255, 255, 255, .5)',
    borderColor: 'rgba(0, 0, 0, 0.1)',
    userInfoBg: 'rgba(248, 165, 165, .1)'
  }
})